import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { retryActivateReducer } from './retry-store/retry-reducer';
import { spinnerActivateReducer } from './spinner-store/spinner.reducer';

const rootReducer = combineReducers({
    values: () => [true, false],
    isActive: spinnerActivateReducer,
    isRetry: retryActivateReducer
});

export const store = configureStore(
    {
        reducer: rootReducer
    }
);

export type RootState = ReturnType<typeof rootReducer>;